<template lang="pug">

q-page
  q-list
    q-item.q-pa-md(
      :to="v.to"
      v-for="v in items" clickable)
      q-item-section(avatar)
        template(v-if="v.avatarType === 'text'")
          q-avatar(:color="v.avatarColor" text-color="white" size="50px")
            span(style="font-size:14px;font-weight:bold;") {{v.avatarText}}
        template(v-else-if="v.avatarType === 'icon'")
          q-avatar(:color="v.avatarColor" text-color="white" size="50px" :icon="v.avatarIcon")
        template(v-else-if="v.avatarType === 'image'")
          q-avatar(:color="v.avatarColor" text-color="white" size="50px")
            img(:src="v.avatarImage" style="width:75%;height:75%;")
      q-item-section
        q-item-label.text-h6 {{v.title}}
        q-item-label(caption line="2") {{v.caption}}

</template>

<style>
</style>

<script>
export default {
  data: function () {
    return {
      items: [
        {
          title: "U2M",
          caption: "User to Machine",
          to: "/u2m",
          avatarType: "icon",
          avatarIcon: "photo_camera_front",
          avatarColor: "amber-8",
        },
        {
          title: "Manual",
          caption: "Let's get our hands dirty",
          to: "/manual",
          avatarType: "icon",
          avatarIcon: "handyman",
          avatarColor: "grey-8",
        },
        {
          title: "Chat",
          caption: "Let's chat",
          to: "/chat",
          avatarType: "icon",
          avatarIcon: "chat",
          avatarColor: "green",
        },
        {
          title: "Video",
          caption: "Let's call",
          to: "/video",
          avatarType: "icon",
          avatarIcon: "videocam",
          avatarColor: "blue",
        },
      ]
    }
  }
}
</script>
